import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { newAction } from "../../../../common/factory/action.factory";
import { saveFlow } from "../../../../redux/actions/integrationActions";
import { useNavigate } from "react-router-dom";
import Select from "@atlaskit/select";
import { ActionRenderOptions } from "../../../../common/constants/core/action.constants";
import Button from "@atlaskit/button/new";
import { getSelectActionOptions } from "../../../../common/utils/integration.util";
import { getConnectionOptions } from "../../../../common/utils/connections.util";
import { ActionType } from "../../../../common/interfaces/flow/action/ActionType";
import { scriptedActionTemplate } from "../../../../common/factory/script.factory";
const CreateActionPage = ({ close }) => {
  const flow = useSelector((state) => state.integration.flow);
  const [uiRender, setUiRender] = useState(ActionRenderOptions[0]);
  const [parent, setParent] = useState({ label: "-None-", value: "" });
  const [renderOptions, setRenderOptions] = useState(ActionRenderOptions);
  const [parentOptions, setParentOptions] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const optionsWithConnection = getConnectionOptions(renderOptions);
    if (
      optionsWithConnection &&
      optionsWithConnection.length !== renderOptions.length
    ) {
      setRenderOptions(optionsWithConnection);
    }
    const newParentOptions = getSelectActionOptions(flow.actions, true);
    if (newParentOptions && newParentOptions.length !== parentOptions) {
      setParentOptions(newParentOptions);
    }
  }, [flow]);

  const onSelectUIRender = (value) => {
    setUiRender(value);
  };
  const onSelectParent = (value) => {
    setParent(value);
  };
  const onCreate = () => {
    const action = newAction(
      flow,
      uiRender.title,
      parent.value,
      uiRender.value
    );
    if (uiRender.value === ActionType.SCRIPT_ACTION_TYPE) {
      action.type = ActionType.SCRIPT_ACTION_TYPE;
      action.script = scriptedActionTemplate;
    }
    flow.actions = flow.actions ? [...flow.actions, action] : [action];
    dispatch(saveFlow(flow));
    close(false);

    navigate("/integration/" + flow.id + "/action/" + action.id);
  };

  return (
    <div className="ihub-sidebar-action-widget-add-popup-menu">
      <span className="atlassian-theme">Action:</span>
      <Select
        name="uiRenderType"
        options={renderOptions}
        value={uiRender}
        onChange={onSelectUIRender}
      />
      <br />
      <span className="atlassian-theme">Parent Action:</span>
      <Select
        name="parentAction"
        options={parentOptions}
        value={parent}
        onChange={onSelectParent}
      />
      <br />
      <Button appearance="primary" onClick={onCreate}>
        Create
      </Button>
    </div>
  );
};
export default CreateActionPage;
